import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页', isAuthenticated: false }
  },
  {
    path: '/',
    redirect: {
      name: 'Home'
    }
  },
  {
    path: '/Download',
    name: 'Download',
    component: resolve => require(['@/views/Download'], resolve),
    meta: { title: '下载', isAuthenticated: false }
  },
  {
    path: '/AnswerQuestion',
    name: 'AnswerQuestion',
    component: resolve => require(['@/views/AnswerQuestion'], resolve),
    meta: { title: '智能检测', isAuthenticated: true }
  },
  {
    path: '/ViewResult',
    name: 'ViewResult',
    component: resolve => require(['@/views/ViewResult'], resolve),
    meta: { title: '查看答题结果', isAuthenticated: true }
  },
  {
    path: '/Appointment',
    name: 'Appointment',
    component: resolve => require(['@/views/appointment/AppointmentContainer'], resolve),
    meta: { title: '查看答题结果', isAuthenticated: false },
    children: [
      {
        path: '', // 不加在path前加 /
        name: 'AppointmentSearchDoctor',
        component: () => import('@/views/appointment/AppointmentSearchDoctor'),
        meta: { title: '查询医生', isAuthenticated: true }
      },
      {
        path: 'AppointmentDoctorInfo',
        name: 'AppointmentDoctorInfo',
        component: () => import('@/views/appointment/AppointmentDoctorInfo'),
        meta: { title: '预约医生', isAuthenticated: true }
      },
      {
        path: 'AppointmentDetail',
        name: 'AppointmentDetail',
        component: () => import('@/views/appointment/AppointmentDetail'),
        meta: { title: '预约详细', isAuthenticated: true }
      }
    ]
  },
  {
    path: '/404',
    component: resolve => require(['@/views/Page404'], resolve),
    hidden: true,
    meta: { title: '页面不存在', isAuthenticated: false }
  },
  {path: '*', redirect: '/404', hidden: true}
]

const router = new VueRouter({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js